import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFilter } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";

const baseUrl = "/api/sif/nacinOznacitve";

export const getMarkingTypes = createAsyncThunk(
  "markingType/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        { page: 0, size: 1000 },
        new ApiFilter().or((orGroup) => {
          orGroup.where("veljaZaKoze", "EQ", true);
          orGroup.where("veljaZaOvce", "EQ", true);
        })
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const markingTypeSlice = createSlice({
  name: "markingTypes",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMarkingTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getMarkingTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.content || [];
      })
      .addCase(getMarkingTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default markingTypeSlice.reducer;
